import { Zap, Sun, HardHat, Cog, Building2, TrainFront } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const INDUSTRIES = [
    { icon: Zap, name: "Panel Builders", note: "LT panels, control wiring & feeders" },
    { icon: Sun, name: "Solar EPC", note: "DC cabling for rooftops & parks" },
    { icon: HardHat, name: "Electrical Contractors", note: "Site-ready reels, cut to length" },
    { icon: Cog, name: "Machine Builders", note: "Control & flexible cable lines" },
    { icon: Building2, name: "Real Estate", note: "Fire-safe FRLS building wires" },
    { icon: TrainFront, name: "Rail & Infra", note: "Armoured runs for tough sites" },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function ClientsIndustries() {
    return (
        <section className="relative bg-paper py-20 lg:py-28" data-testid="clients-industries-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
                <Reveal className="mb-12 max-w-2xl">
                    <Eyebrow className="mb-5">07 — Who We Power</Eyebrow>
                    <h2 className="font-display font-bold tracking-tight leading-[1.05] text-3xl sm:text-4xl lg:text-5xl text-ink">
                        Trusted across <em className="text-copper">every trade.</em>
                    </h2>
                </Reveal>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                    {INDUSTRIES.map((ind, i) => {
                        const Icon = ind.icon;
                        return (
                            <Reveal key={ind.name} delay={(i % 3) * 0.08}>
                                <div
                                    data-testid={`industry-card-${slug(ind.name)}`}
                                    className="group rounded-md border border-line bg-white p-6 h-full shadow-sm hover:shadow-xl hover:border-copper/40 hover:-translate-y-1 transition-all duration-500"
                                >
                                    <span className="w-11 h-11 rounded-full bg-copper-light flex items-center justify-center text-copper mb-4 group-hover:bg-copper group-hover:text-white transition-colors duration-300">
                                        <Icon size={19} />
                                    </span>
                                    <h3 className="font-display font-semibold text-lg text-ink leading-snug">{ind.name}</h3>
                                    <p className="text-mist text-sm mt-1.5 leading-relaxed">{ind.note}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
